export const UserConversationConditions = [
  {name: "ادمین (ADMIN)", value: 0},
  {name: "مخفی (HIDDEN)", value: 1},
  {name: "میوت (MUTE)", value: 2},
  {name: "غیرفعال (DISABLE)", value: 3},
];

export const UserConversationConditionTypes = [
  {id: 1, name:  "ادمین (ADMIN)"},
  {id: 2, name: "مخفی (HIDDEN)"},
  {id: 3, name: "سکوت (MUTE)"},
  {id: 4, name: "غیرفعال (DISABLE)"},
];
